import {styled} from "@mui/material";
import {pxToRem} from "@services/theme/utils";

export const SkillsListWrapper = styled('div')({
    '&:last-of-type': {
        marginBottom: pxToRem(10),
    },
})
